// src/pages/HomePage.tsx
import Hero from '@/components/Hero';
import Services from '@/components/Services';
import Contact from '@/components/Contact';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Services />
      <Contact />
    </>
  );
};

export default HomePage;
